var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard_Icon",
    "data-name": "Dashboard Icon",
    d: "M7.841.5H1.371A.871.871,0,0,0,.5,1.371v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871V1.371A.871.871,0,0,0,7.841.5Zm9.788,0h-6.47a.871.871,0,0,0-.871.871v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871V1.371A.871.871,0,0,0,17.629.5ZM7.841,10.288H1.371a.871.871,0,0,0-.871.871v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871v-6.47A.871.871,0,0,0,7.841,10.288Zm9.788,0h-6.47a.871.871,0,0,0-.871.871v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871v-6.47A.871.871,0,0,0,17.629,10.288Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActiveIcon);
export default __webpack_public_path__ + "static/media/DashboardActiveIcon.79fc210978c140e9dc4b2c77aa0fcbb4.svg";
export { ForwardRef as ReactComponent };